// import NetInfo from '@react-native-community/netinfo';
import { Middleware } from 'redux';

const createNetworkMiddleware = (): Middleware => () => next => {
  // Subscribe to Connection Information
  // NetInfo.addEventListener(res => store.dispatch(updateNetworkState(res)));

  return action => next(action);
};

export default createNetworkMiddleware;
